const permissions = {
    search_placeholder: 'ค้นหาตามชื่อ API หรือสิทธิ์การเข้าถึง',
    search_placeholder_without_api: 'ค้นหาตามชื่อสิทธิ์การเข้าถึง',
    name_column: 'สิทธิ์การเข้าถึง',
    description_column: 'คำอธิบาย',
    api_column: 'API',
    placeholder_title: 'สิทธิ์การเข้าถึง',
    placeholder_description: 'สิทธิ์การเข้าถึงหมายถึงการได้รับอนุญาตให้เข้าถึงทรัพยากร (เราเรียกว่าทรัพยากร API)',
    edit: 'แก้ไขสิทธิ์การเข้าถึง',
    delete: 'ลบสิทธิ์การเข้าถึง',
    remove: 'นำสิทธิ์การเข้าถึงออก',
    edit_title: 'แก้ไขสิทธิ์การเข้าถึง API',
};
export default Object.freeze(permissions);
